var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.subDomainName)?_c('span',[_c('custom-spinner-logo',{attrs:{"text_trad":_vm.text_trad}})],1):_c('span',[_c('default-spinner-logo',{attrs:{"text_trad":_vm.text_trad}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }